import React from 'react'
import Seo from '../components/Seo'
import Nav from '../components/Nav'
//import Bio from '../components/Bio/Bio'
import { rhythm, scale } from '../utils/typography'
import Obfuscate from 'react-obfuscate'
//import myutils from '../utils/myutils'

class MyResume extends React.Component {

  render() {
    const moment = require("moment")
    const now = moment(new Date());
    const r = require('../../content/resume-json/resume-data.js')
    const config = require('../../content/meta/config')
    //const { data } = this.props
    //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
    const d = {
      title: config.siteTitle,
      description: config.siteDescription,
      image: config.siteImage,
      url: config.siteUrl,
      keywords: config.resumeKeywords,
      datePublished: "2018-07-01",
      dateUpdated: now.format("YYYY-MM-DD")
    }
    return (
      <div
        style={{
          marginTop: rhythm(1 / 4),
        }}
      >
        <Seo data={d} pageType='resume' />
        <Nav />
        <div
          style={{
            marginBottom: 0,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <h1 style={{
            marginTop: '1rem'
          }}>
            {' '}
            <strong> {r['my_name'].toUpperCase()}</strong>
          </h1>
        </div>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              fontSize: '0.8rem',
            }}
          >
            <p
              style={{
                marginBottom: '0px',
              }}
            >
              Phone: <Obfuscate tel={r['mobile']} />
            </p>
            <p
              style={{
                marginBottom: '0px',
              }}
            >
              Email: <Obfuscate email={r['email']} />
            </p>
            <p
              style={{
                marginBottom: '0px',
              }}
            >
              Website: <a href='//www.chetanarya.com'>www.chetanarya.com</a>
            </p>
          </div>
        </div>

        <MySimpleList listTitle="Summary" list={r.headlines} />                
        <JobIndex jobs={r.jobs} />
        <MySimpleList listTitle="Technical Skills" list={r.techSkills} />
        <Award awards={r.awards} />
        <Education educations={r.education} />
        <SocialLinksIndex contactPoints={r.contact_points} />
        <Copyright copyright={r.copyright} />
      </div>
    )
  }
}
class SocialLinksIndex extends React.Component {
  render() {
    const contactPoints = this.props.contactPoints
    const j = contactPoints.map(cp => (
      <li
        key={cp.name}
        style={{
          marginBottom: 0,
          fontSize: '0.8rem',
        }}
      >
        {cp.name} @ <a href={cp.url}> {cp.url}</a>
      </li>
    ))

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <h3
            style={{
              // textDecoration: 'underline',
              marginTop: '1rem',
            }}
          >
            Social Locators
          </h3>
        </div>
        <div
          style={{
            //...scale(0.1),
            fontWeight: 'lighter',
          }}
        >
          <ol>{j}</ol>
        </div>
      </div>
    )
  }
}

class MySimpleList extends React.Component {
  render() {
    const list = this.props.list
    const listTitle = this.props.listTitle
    const j = list.map(hl => (
      <li
        key={hl}
        style={{
          marginBottom: 0,
          fontSize: '0.8rem',
        }}
      >
        {hl}
      </li>
    ))
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <h3
            style={{
              //textDecoration: 'underline',
              marginTop: '1rem',
            }}
          >
            {listTitle}
          </h3>
        </div>
        <div
          style={{
            //...scale(0.1),
            fontWeight: 'lighter',
          }}
        >
          <ol
            style={
              {
                // listStyle: 'none',
              }
            }
          >
            {j}
          </ol>
        </div>
      </div>
    )
  }
}

class JobIndex extends React.Component {
  render() {
    const jobs = this.props.jobs
    const j = jobs.map(job => <Job key={job.title} job={job} />)

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <h3
            style={{
              // textDecoration: 'underline',
              marginTop: '1rem',
            }}
          >
            Employment History
          </h3>
        </div>
        {j}
      </div>
    )
  }
}


class Copyright extends React.Component {

  render() {
    const cr = this.props.copyright

    const dangerousCR = { __html: '<p style="margin-bottom:0px;">' + cr + '</p>' }
    return (
      <div dangerouslySetInnerHTML={dangerousCR} style={{
        fontSize: '0.6rem'
      }} ></div>
    )
  }
}
class Job extends React.Component {
  render() {
    const job = this.props.job
    const j = job.roles
      .map(
        role =>
          '<li style="font-size: 0.8rem; margin-bottom: 0px;">' + role + '</li>'
      )
      .join('')
    //console.log(j)
    const dangerousJ = { __html: j }
    //debugger
    return (
      <div>
        <div
          style={{
            marginTop: '0px',
          }}
        >
          <h6
            style={{
              marginTop: '1rem',
            }}
          >
            <strong>{job.title}</strong> at <strong>{job.org}, {job.location}</strong> (<strong>
              {' '}
              {job.dates}{' '}
            </strong>)
          </h6>
        </div>
        <div
          style={{
            //...scale(0.1),
            fontWeight: 'lighter',
          }}
        >
          <ol dangerouslySetInnerHTML={dangerousJ} />
          {/* <ol>{j}</ol> */}
        </div>
      </div>
    )
  }
}

class Education extends React.Component {
  render() {
    const educations = this.props.educations
    const j = educations.map(education => (
      <ol
        key={education}
        style={{
          marginBottom: 0,
          fontSize: '0.8rem',
          marginLeft: 0,
        }}
      >
        {education}
      </ol>
    ))

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <h3
            style={{
              marginTop: '1rem',
            }}
          >
            Education
          </h3>
        </div>
        <div
          style={{
            fontWeight: 'lighter',
          }}
        >
          {j}
        </div>
      </div>
    )
  }
}


class Award extends React.Component {
  render() {
    const awards = this.props.awards
    const j = awards.map(award => (
      <li
        key={award}
        style={{
          marginBottom: 0,
          fontSize: '0.8rem',
        }}
      >
        {award}
      </li>
    ))

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          <h3
            style={{
              // textDecoration: 'underline',
              marginTop: '1rem',
            }}
          >
            Awards
          </h3>
        </div>
        <div
          style={{
            //...scale(0.1),
            fontWeight: 'lighter',
          }}
        >
          <ol>{j}</ol>
        </div>
      </div>
    )
  }
}

export default MyResume

export const pageQuery = graphql`
  query ResumeQuery {
          site {
        siteMetadata {
          title
        facebook {
          appId
        }
        }
      }
    }
  `



// WEBPACK FOOTER //
// ./src/pages/index.js